interface Config {
    baseUrl : string;
}

export const conf: Config = {
    baseUrl : "https://manimahesh.netgen.work/api",
    // baseUrl : process.env.REACT_APP_API_BASE_URL as string,
}
